import { type DocumentNode, gql } from '@apollo/client';

const newMediaPermission: DocumentNode = gql`
  mutation new_media_permission(
    $profileId: ID!
    $permissionsGroupId: ID!
    $canEdit: Boolean
    $canShare: Boolean
    $canDownload: Boolean
    $canDelete: Boolean
    $hires: Boolean
  ) {
    createMediaPermission(
      profileId: $profileId
      permissionsGroupId: $permissionsGroupId
      canEdit: $canEdit
      canShare: $canShare
      canDownload: $canDownload
      canDelete: $canDelete
      hires: $hires
    ) {
      mediaPermission {
        permissionsGroup {
          id
          name
          description
          mediaGroups {
            edges {
              node {
                id
                name
              }
            }
          }
          mediapermissionSet {
            edges {
              node {
                id
                profile {
                  id
                  user {
                    id
                    username
                    email
                  }
                  firstName
                  lastName
                }
                canEdit
                canShare
                canDownload
                canDelete
                hires
              }
            }
          }
        }
      }
    }
  }
`;

export default newMediaPermission;
